import { render } from "./QuizVita.vue?vue&type=template&id=33e580b6&scoped=true"
import script from "./QuizVita.vue?vue&type=script&lang=js"
export * from "./QuizVita.vue?vue&type=script&lang=js"

import "./QuizVita.vue?vue&type=style&index=0&id=33e580b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e580b6"]])

export default __exports__